export default __webpack_public_path__ + "static/media/ransomewareRealcase-mobile-en.2d6ef9ca.png";